(function () {
  var debug = /[?&]swymDebug=1\b/.test(location.search);

  function checkPrivacyConsent() {
    try {
      if (window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed === 'function') {

        var allowed = window.Shopify.customerPrivacy.preferencesProcessingAllowed();

        if (!allowed) {
          if (window.Shopify.customerPrivacy.setTrackingConsent) {
            window.Shopify.loadFeatures([
              {
                name: 'consent-tracking-api',
                version: '0.1',
              },
            ], function (error) {
              if (error) {
                console.warn('Failed to load consent tracking:', error);
              }
            });
          }

          var banner = document.createElement('div');
          banner.style.cssText = 'background:#fff3cd;color:#664d03;border:1px solid #ffecb5;padding:12px;margin:10px;border-radius:4px;text-align:center;';
          banner.innerHTML = '<p>Please accept cookies to use the wishlist feature.</p>';
          var container = document.getElementById('wishlist-page') || document.body;
          container.insertBefore(banner, container.firstChild);

          return false;
        }
        return true;
      }
      return true;
    } catch (e) {
      if (debug) console.warn('Privacy check failed:', e);
      return true;
    }
  }

  if (!checkPrivacyConsent()) {
    if (debug) console.log('Wishlist blocked: customer privacy preferences not allowed');
    return;
  }

  function ensureGlobalDebugBanner() {
    var existing = document.getElementById('wishlist-debug-global');
    if (existing) return existing;
    var b = document.createElement('div');
    b.id = 'wishlist-debug-global';
    b.style.cssText = 'position:sticky;top:0;z-index:9999;background:#fff3cd;color:#664d03;border-bottom:1px solid #ffecb5;padding:8px 12px;font-size:13px';
    b.setAttribute('role', 'status');
    var host = (location.pathname || '') + (location.search || '');
    b.textContent = 'Swym Wishlist Debug: section #wishlist-page not found on this template. Ensure the page uses the "page.wishlist" template (or JSON template) that includes the Wishlist section. URL: ' + host;
    document.body && document.body.firstElementChild ? document.body.insertBefore(b, document.body.firstElementChild) : document.documentElement.appendChild(b);
    return b;
  }
  if (debug) {
    setTimeout(function () {
      if (!document.getElementById('wishlist-page')) {
        var banner = ensureGlobalDebugBanner();
        var sdk = !!window._swat;
        var apiType = typeof (window._swat && window._swat.api);
        var hasFetch = !!(window._swat && window._swat.fetchLists);
        var note = document.createElement('div');
        note.textContent = 'this is from assets/wishlist.js';
        note.textContent = 'SDK detected: ' + (sdk ? 'yes' : 'no') + ', swat.api: ' + apiType + ', fetchLists: ' + (hasFetch ? 'yes' : 'no');
        banner.appendChild(note);
        try {
          var base = (function () {
            try {
              if (window.SWYM_API_BASE) return String(window.SWYM_API_BASE).replace(/\/$/, '');
              var s = window._swat;
              var b = (s && (s.apiHost || s.host || (s.config && (s.config.apiHost || s.config.host || s.config.baseUrl)))) ||
                (window.SwymUtils && SwymUtils.Config && (SwymUtils.Config.apiHost || SwymUtils.Config.host || SwymUtils.Config.baseUrl)) || '';
              return String(b || '').replace(/\/$/, '');
            } catch (e) { return ''; }
          })();
          var line2 = document.createElement('div');
          line2.textContent = 'API base: ' + (base || '(unknown)');
          banner.appendChild(line2);
        } catch (e) { }
      }
    }, 0);
  }

  
  if (!document.getElementById('wishlist-page') && !document.getElementById('wishlist-mount')) {
    if (debug) console.log('Wishlist: no #wishlist-mount on this template, skipping page render');
    return;
  }

  if (!document.getElementById('wishlist-header-styles')) {
    var styles = document.createElement('style');
    styles.id = 'wishlist-header-styles';
    styles.textContent = `
      .wishlist-header { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 24px; }
      .wishlist-header h1 { margin: 0; flex: 0 0 auto; font-size: 28px; font-weight: 600; }
      .custom-wishlist-count { font-size: 0.8em; color: #666; font-weight: normal; margin-left: 10px; }
      .wishlist-header .share-list { flex: 0 0 auto; margin-left: auto; }
      .wishlist-actions { flex-basis: 100%; display: flex; flex-wrap: wrap; gap: 16px; align-items: flex-start; }
      .wishlist-share-btn { display: inline-flex; align-items: center; justify-content: center; padding: 8px 16px; gap: 6px; font-size: 13px; font-family: 'Roboto'; }
      .wishlist-share-btn svg { flex-shrink: 0; }
      
      .share-drawer-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 9998; opacity: 0; visibility: hidden; transition: opacity 0.3s ease, visibility 0.3s ease; }
      .share-drawer-overlay.active { opacity: 1; visibility: visible; }
      .share-drawer { position: fixed; top: 0; right: -400px; width: 400px; max-width: 90vw; height: 100vh; background: white; box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1); z-index: 9999; overflow-y: auto; transition: right 0.3s ease; padding: 18px; }
      .share-drawer.active { right: 0; }
      .share-drawer-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
      .share-drawer-header h2 { margin: 0; font-size: 20px; font-weight: 600; font-family: 'Roboto' !important; }
      .share-drawer-close { background: none; border: none; font-size: 24px; cursor: pointer; padding: 4px 8px; color: #666; line-height: 1; }
      .share-drawer-close:hover { color: #000; }
      .share-drawer-description { font-weight: 500; margin-bottom: 12px; font-size: 16px; color: #000000; font-family: 'Roboto'; }
      .share-drawer-form { display: flex; flex-direction: column; gap: 17px; }
      .share-drawer-field { display: flex; flex-direction: column; gap: 6px; }
      .share-drawer-field label { font-size: 14px; font-weight: 500; color: #333; display: none; }
      .share-drawer-field input, .share-drawer-field textarea { padding: 8px 12px 36px; border: 1px solid rgba(34, 34, 34, 0.1333); border-radius: 8px; font-weight: 400; font-size: 14px; font-family: 'Roboto'; color: rgba(80, 80, 80, 1); }
      .share-drawer-field input:focus, .share-drawer-field textarea:focus { outline: none; border-color: #4CAF50; }
      .share-drawer-field textarea { min-height: 154px; resize: vertical; }
      .share-drawer-submit { background: #00A655; color: #FFFFFF; border: none; padding: 12px 24px; border-radius: 4px; font-size: 16px; font-weight: 500; cursor: pointer; transition: background 0.2s; margin-top: 3px; }
      .share-drawer-submit:hover { background: #45a049; }
      .share-drawer-divider { text-align: center; margin: 20px 0; color: #999; font-size: 14px; }
      .share-drawer-social { display: flex; justify-content: center; gap: 12px; }
      .share-drawer-social-btn { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px 44px; border: 1px solid #E1E1E1; border-radius: 4px; background: white; cursor: pointer; font-size: 14px; font-weight: 500; transition: all 0.2s; font-family: 'Roboto'; color: #696969; }
      .share-drawer-social-btn:hover { border-color: #999; background: #f9f9f9; }
      .share-drawer-social-btn svg { flex-shrink: 0; }
      
      .wishlist-item__image-wrapper { position: relative; display: inline-block; width: 100%; }
      .wishlist-item__image { display: block; position: relative; z-index: 1; text-decoration: none; }
      .wishlist-item__image img { display: block; width: 100%; height: auto; }
      .wishlist-heart-icon { position: absolute; top: 11px; right: 11px; width: 25px; height: 25px; border-radius: 50%; background: white; border: none; display: flex; align-items: center; justify-content: center; z-index: 3; cursor: pointer; padding: 0; transition: transform 0.2s ease, width 0.2s ease, border-radius 0.2s ease, padding 0.2s ease; pointer-events: auto;  white-space: nowrap; overflow: visible; }
      .wishlist-heart-icon:hover { transform: scale(1.1); }
      .wishlist-heart-icon:active { transform: scale(0.95); }
      .wishlist-heart-icon svg { fill: #00a65b; stroke: #00a65b; width:18px !important; min-width:18px;  height: 18px !important; }
      .wishlist-heart-icon.wishlist-removing { padding: 0 10px; font-size: 12px; font-weight: 500; color: #333; min-width: auto; background: none !important; }
      
      .wishlist-cart-icon { display: none; position: absolute; top: 37px; right: 10px; width: 36px; height: 36px; border-radius: 50%; border: none; align-items: center; justify-content: center; z-index: 3; cursor: pointer; padding: 0; transition: transform 0.2s ease; pointer-events: auto; }
      .wishlist-cart-icon:hover { transform: scale(1.1); }
      .wishlist-cart-icon:active { transform: scale(0.95); }
      
      .wishlist-cart-icon.wishlist-quick-add-btn {
        width: 26px !important;
        height: 26px !important;
        padding: 6px !important;
        background:white !important;
        border-radius: 50% !important;
        bottom: auto !important;
        top:42px !important;
        right: 10px !important;
        left: auto !important;
        transform: none !important;
      }

      .wishlist-cart-icon.m-svg-icon--medium {
        width:14px !important;
        height: 14px !important;
      }
      .wishlist-cart-icon.wishlist-quick-add-btn:hover { transform: scale(1.1) !important; }

      @media (max-width: 768px) { 
        .wishlist-cart-icon { display: flex !important; } 
        .wishlist-item__buttons .wishlist-add-to-cart { display: none; } 
        .wishlist-quick-add-btn:not(.wishlist-cart-icon) { display: none !important; }

      }
      .notify-me-popup-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 10000; display: flex; align-items: center; justify-content: center; opacity: 0; visibility: hidden; transition: opacity 0.3s ease, visibility 0.3s ease; }
      .notify-me-popup-overlay.active { opacity: 1; visibility: visible; }
      .notify-me-popup { background: white; border: 1px solid #0066CC; border-radius: 8px; padding: 24px; max-width: 456px; width: 90%; position: relative; transform: scale(0.9); transition: transform 0.3s ease; }
      .notify-me-popup-overlay.active .notify-me-popup { transform: scale(1); }
      .notify-me-popup-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
      .notify-me-popup-title { font-size: 20px; font-weight: 600; color: #000; margin: 0; }
      .notify-me-popup-close { background: none; border: none; font-size: 24px; cursor: pointer; padding: 0; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; color: #666; }
      .notify-me-popup-close:hover { color: #000; }
      .notify-me-popup-description { font-size: 14px; color: #666; margin-bottom: 20px; }
      .notify-me-popup-form { display: flex; flex-direction: column; gap: 16px; }
      .notify-me-popup-field { display: flex; flex-direction: column; gap: 6px; }
      .notify-me-popup-field label { font-size: 14px; font-weight: 500; color: #333; }
      .notify-me-popup-field input { padding: 10px 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; font-family: inherit; }
      .notify-me-popup-field input:focus { outline: none; border-color: #0066CC; }
      .notify-me-popup-submit { background: #00A655; color: white; border: none; padding: 12px 24px; border-radius: 4px; font-size: 16px; font-weight: 500; cursor: pointer; width: 100%; transition: background 0.2s; }
      .notify-me-popup-submit:hover { background: #008844; }
      .notify-me-popup-submit:disabled { background: #ccc; cursor: not-allowed; }
      .notify-me-popup-error { color: #d32f2f; font-size: 12px; margin-top: 4px; }
    .notify-me-popup-success { color: #00A655; font-size: 14px; margin-top: 8px; text-align: center; }
      
      .wishlist-quick-add-btn { border-radius:4px !important; position: absolute; bottom: 10px; left: 10px; right: 10px; width: auto !important; border: none; padding: 10px 20px !important; font-weight: 400; font-size: 13px; cursor: pointer; transform: translateY(calc(100% + 10px)); transition: transform 0.3s ease, background 0.3s, color 0.3s; z-index: 5; letter-spacing: 0px; margin: 0 !important; }
      .wishlist-item__image-wrapper { overflow: hidden; }
      .wishlist-item__image-wrapper:hover .wishlist-quick-add-btn { transform: translateY(0); }
      
      .wishlist-qv-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); z-index: 99999; display: flex; justify-content: center; align-items: center; opacity: 0; visibility: hidden; transition: opacity 0.3s, visibility 0.3s; }
      .wishlist-qv-overlay.active { opacity: 1; visibility: visible; }
      .wishlist-qv-modal { background: white; width: 90%; max-width: 1000px; max-height: 90vh; overflow-y: auto; position: relative; border-radius: 4px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); display: flex; flex-direction: column; }
      .wishlist-qv-close { position: absolute; top: 20px; right: 20px; background: white; border: none;border-radius:50%; font-size: 22px; line-height: 1; cursor: pointer; z-index: 100; color: #333; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; }
      .wishlist-qv-close:hover { color: #000; }
      #wishlist-qv-content { flex: 1; }
      .m-product-quickview { padding: 30px; }
      @media (max-width: 768px) { 
       .wishlist-page .swiper-pagination .swiper-pagination-bullet-active:after{
      border-color : transparent  !important;
      }
        .m-product-quickview { flex-direction: column; padding: 15px; } 
        .m-product-quickview--media, .m-product-quickview--info { width: 100% !important; }
      }
     
      .wishlist-page .swym-wishlist-collections-v2-container .swym-wishlist-collections-v2  { display: none !important; }

      button[disabled] span:not([class*=spinner]):not([class*=icon]), button:disabled span:not([class*=spinner]):not([class*=icon]){
      
    visibility: visible !important;
    }

    .m-product-quickview .swiper-button-control {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        opacity: 0;
        transition: opacity 0.3s ease;
        background: white;
        border-radius: 50%;
        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        cursor: pointer;
    }
    .m-product-quickview .swiper-button-control:hover {
        background: #f0f0f0;
    }
    .m-product-quickview .swiper-button-prev { left: 10px; }
    .m-product-quickview .swiper-button-next { right: 10px; }

    .m-product-quickview .swiper-container:hover .swiper-button-control {
        opacity: 1;
    }

    .m-main-product .m-quantity, .m-product-quickview .m-quantity {width :100%}

    @media (max-width: 768px) {
        .m-product-quickview .swiper-pagination {
            display: flex !important;
            position: relative !important; /* Move out of image area */
            bottom: auto !important;
            left: 0;
            width: 100%;
            justify-content: center;
            align-items: center;
            z-index: 10;
            margin-top: 10px;
            margin-bottom: 0px;
        }
        
            .m-product-quickview .m-product-quickview--info .m-product-title{
            padding-top:20px;
            }
        
        .m-product-quickview .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: #000;
            opacity: 1; /* Solid black for inactive */
            margin: 0 6px !important;
            border-radius: 50%;
            transition: all 0.3s ease;
        }
        
        .m-product-quickview .swiper-pagination-bullet-active {
            background: transparent;
            border: 1px solid #000;
            opacity: 1;
            transform: scale(1.4); /* Make active slightly larger/hollow */
        }

        .m-product-quickview .swiper-button-control {
            display: flex !important;
            opacity: 1 !important; /* Always visible on mobile */
            width: 32px;
            height: 32px;
        }
    }
    `;
    document.head.appendChild(styles);
  }

  var section = document.getElementById('wishlist-page');
  if (!section) {
    var mount = document.getElementById('wishlist-mount');
    var wrapper = document.createElement('section');
    wrapper.id = 'wishlist-page';
    wrapper.className = 'wishlist-page';
    wrapper.setAttribute('data-page-size', '12');
    wrapper.setAttribute('data-api-base', '');
    wrapper.setAttribute('data-list-prefix', '');
    wrapper.innerHTML = [
      '<div class="page-width">',
      '  <header class="wishlist-header">',
      '    <div class="custom-wishlist-shrebutton">',
      '    <h1>My Wishlist<span id="wishlist-count" class="custom-wishlist-count"></span></h1>',
      '    <div class="share-list">',
      '      <button id="wishlist-share" class="button wishlist-share-btn">',
      '        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none" style="margin-right:6px">',
      '          <path d="M4.52672 8.47411L9.08005 11.1274M9.07338 3.80745L4.52672 6.46078M12.8 2.80078C12.8 3.90535 11.9046 4.80078 10.8 4.80078C9.69548 4.80078 8.80005 3.90535 8.80005 2.80078C8.80005 1.69621 9.69548 0.800781 10.8 0.800781C11.9046 0.800781 12.8 1.69621 12.8 2.80078ZM4.80005 7.46745C4.80005 8.57202 3.90462 9.46745 2.80005 9.46745C1.69548 9.46745 0.800049 8.57202 0.800049 7.46745C0.800049 6.36288 1.69548 5.46745 2.80005 5.46745C3.90462 5.46745 4.80005 6.36288 4.80005 7.46745ZM12.8 12.1341C12.8 13.2387 11.9046 14.1341 10.8 14.1341C9.69548 14.1341 8.80005 13.2387 8.80005 12.1341C8.80005 11.0295 9.69548 10.1341 10.8 10.1341C11.9046 10.1341 12.8 11.0295 12.8 12.1341Z" stroke="#1E1E1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>',
      '        </svg>',
      '        Share wishlist',
      '      </button>',
      '      <input id="wishlist-share-url" type="text" readonly style="position:absolute;left:-9999px" />',
      '    </div>',
      '    </div>',
      '  </header>',

      '  <div id="wishlist-items" class="wishlist-items custom-container" aria-live="polite"></div>',
      '  <nav class="wishlist-pagination" aria-label="Wishlist pagination">',
      '    <button id="wishlist-prev" class="button" disabled>Previous</button>',
      '    <span id="wishlist-page-info"></span>',
      '    <button id="wishlist-next" class="button" disabled>Next</button>',
      '  </nav>',
      '</div>',

      '<div class="share-drawer-overlay" id="share-drawer-overlay"></div>',
      '<div class="share-drawer" id="share-drawer">',
      '  <div class="share-drawer-header">',
      '    <h2>Share Wishlist</h2>',
      '    <button class="share-drawer-close" id="share-drawer-close" aria-label="Close drawer">&times;</button>',
      '  </div>',
      '  <p class="share-drawer-description">Share your list with friends & family</p>',
      '  <form class="share-drawer-form" id="share-drawer-form">',
      '    <div class="share-drawer-field">',
      '      <label for="share-recipient-email"></label>',
      '      <input type="email" id="share-recipient-email" name="recipientEmail" required placeholder="Recipients Email*" />',
      '    </div>',
      '    <div class="share-drawer-field">',
      '      <label for="share-sender-name"></label>',
      '      <input type="text" id="share-sender-name" name="senderName" required placeholder="Sender Name*" />',
      '    </div>',
      '    <div class="share-drawer-field">',
      '      <label for="share-message"></label>',
      '      <textarea id="share-message" name="message" required placeholder="Message*"></textarea>',
      '    </div>',
      '    <button type="submit" class="share-drawer-submit">Share List</button>',
      '  </form>',
      '  <div class="share-drawer-divider">or share via</div>',
      '  <div class="share-drawer-social">',
      '    <button class="share-drawer-social-btn" id="share-copy-link">Copy link</button>',
      '    <button class="share-drawer-social-btn" id="share-facebook">',
      '      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="23" viewBox="0 0 11 23" fill="none">',
      '        <path d="M6.89441 22.9232V12.4838H10.0375L10.5047 8.39651H6.89441V5.79305C6.89441 4.61359 7.18769 3.80606 8.69844 3.80606H10.6127V0.161977C9.68132 0.0501335 8.7451 -0.00386955 7.80836 0.000215469C5.03014 0.000215469 3.12266 1.90059 3.12266 5.38928V8.38887H0V12.4762H3.12948V22.9232H6.89441Z" fill="#4092FF"/>',
      '      </svg>',
      '      Facebook',
      '    </button>',
      '  </div>',
      '</div>',

      '<div class="wishlist-qv-overlay" id="wishlist-qv-overlay">',
      '  <div class="wishlist-qv-modal">',
      '    <button class="wishlist-qv-close" id="wishlist-qv-close">&times;</button>',
      '    <div id="wishlist-qv-content"></div>',
      '  </div>',
      '</div>',

      '<template id="wishlist-item-template">',
      '  <div class="wishlist-item" data-epi="" data-variantid="">',
      '    <div class="wishlist-item__image-wrapper">',
      '      <a class="wishlist-item__image" href="" aria-label="View product">',
      '        <img src="" alt="" loading="lazy" />',
      '      </a>',
      '      <button type="button" class="wishlist-cart-icon wishlist-quick-add-btn" aria-label="Add to cart">',
      '        <svg class="m-svg-icon--medium" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">',
      '              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.03448C0 0.463154 0.463154 0 1.03448 0H3.25791C4.46059 0 5.47642 0.884556 5.64696 2.06897H18.9655C19.2537 2.06897 19.5288 2.18915 19.7245 2.40057C19.9203 2.61199 20.019 2.89549 19.997 3.18279L19.5032 9.60126C19.3512 11.5775 17.7033 13.1034 15.7213 13.1034H6.96133L7.08933 14.1787C7.10998 14.3521 7.25707 14.4828 7.43174 14.4828H16.2069C16.7782 14.4828 17.2414 14.9459 17.2414 15.5172C17.2414 16.0886 16.7782 16.5517 16.2069 16.5517H7.43174C6.20901 16.5517 5.17942 15.6374 5.03487 14.4233L3.60032 2.37303C3.57967 2.19958 3.43259 2.06897 3.25791 2.06897H1.03448C0.463154 2.06897 0 1.60581 0 1.03448ZM6.71502 11.0345H15.7213C16.6222 11.0345 17.3713 10.3409 17.4403 9.44258L17.8484 4.13793H5.894L6.71502 11.0345Z" fill="#282828"></path>',
      '               <path d="M10.3448 19.3103C10.3448 20.0721 9.72729 20.6897 8.96552 20.6897C8.20374 20.6897 7.58621 20.0721 7.58621 19.3103C7.58621 18.5486 8.20374 17.931 8.96552 17.931C9.72729 17.931 10.3448 18.5486 10.3448 19.3103Z" fill="#282828"></path>',
      ' <path d="M17.2414 19.3103C17.2414 20.0721 16.6238 20.6897 15.8621 20.6897C15.1003 20.6897 14.4828 20.0721 14.4828 19.3103C14.4828 18.5486 15.1003 17.931 15.8621 17.931C16.6238 17.931 17.2414 18.5486 17.2414 19.3103Z" fill="#282828"></path>',
      '  </svg>',
      '      </button>',
      '      <button type="button" class="wishlist-heart-icon" aria-label="Remove from wishlist">',
      '        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">',
      '           <path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="#00a655" stroke-width="1.7px" fill="#00a655" stroke-linecap="round" stroke-linejoin="round"></path>',
      '        </svg>',
      '      </button>',
      '      <button type="button" class="wishlist-quick-add-btn">Quick Add</button>',
      '    </div>',
      '    <div class="wishlist-item__content">',
      '      <a class="wishlist-item__title" href=""></a>',
      '      <div class="wishlist-item__price"></div>',
      '      <div class="wishlist-item__options">',
      '        <select class="wishlist-item__variant" aria-label="Select variant"></select>',
      '      </div>',
      '      <div class="wishlist-item__buttons">',
      '        <button class="button-secondary wishlist-remove">remove</button>',
      '        <button class="button-secondary wishlist-move" title="Move to another list">||</button>',
      '      </div>',
      '    </div>',
      '  </div>',
      '</template>'
    ].join('');

    mount.appendChild(wrapper);
    section = wrapper;
  }

  var pageSize = parseInt(section.getAttribute('data-page-size') || '12', 10);
  var apiBase = (section.getAttribute('data-api-base') || '').trim().replace(/\/$/, '');
  var listPrefix = (section.getAttribute('data-list-prefix') || '').trim();
  var $items = document.getElementById('wishlist-items');
  var $listSelect = document.getElementById('wishlist-list-select');
  var $createList = document.getElementById('wishlist-create-list');
  var $shareBtn = document.getElementById('wishlist-share');
  var $shareUrl = document.getElementById('wishlist-share-url');
  var $prev = document.getElementById('wishlist-prev');
  var $next = document.getElementById('wishlist-next');
  var $pageInfo = document.getElementById('wishlist-page-info');
  var $qvOverlay = document.getElementById('wishlist-qv-overlay');
  var $qvClose = document.getElementById('wishlist-qv-close');
  var $qvContent = document.getElementById('wishlist-qv-content');
  var itemTpl = document.getElementById('wishlist-item-template');

  if ($qvClose) {
    $qvClose.addEventListener('click', function () {
      if ($qvOverlay) $qvOverlay.classList.remove('active');
    });
  }
  if ($qvOverlay) {
    $qvOverlay.addEventListener('click', function (e) {
      if (e.target === $qvOverlay) $qvOverlay.classList.remove('active');
    });
  }

  var resetCtx = /[?&]swymReset=1\b/.test(location.search);
  var restTest = /[?&]swymRest=1\b/.test(location.search);
  function ensureDebugBanner() {
    var existing = document.getElementById('wishlist-debug');
    if (existing) return existing;
    var banner = document.createElement('div');
    banner.id = 'wishlist-debug';
    banner.style.cssText = 'background:#fff3cd;color:#664d03;border:1px solid #ffecb5;padding:8px 12px;margin:10px 0;border-radius:4px;font-size:13px;';
    banner.setAttribute('role', 'status');
    section.prepend(banner);
    return banner;
  }
  function dbg() {
    if (!debug) return;
    var args = Array.prototype.slice.call(arguments);
    var b = ensureDebugBanner();
    var p = document.createElement('div');
    p.textContent = args.map(function (a) { try { return typeof a === 'string' ? a : JSON.stringify(a); } catch (e) { return String(a); } }).join(' ');
    b.appendChild(p);
  }

  function clearSwymClientContext() {
    try {
      var removed = [];
      ['localStorage', 'sessionStorage'].forEach(function (store) {
        var s = window[store]; if (!s) return;
        var keys = []; for (var i = 0; i < s.length; i++) { keys.push(s.key(i)); }
        keys.forEach(function (k) { if (/swym/i.test(k) || /_swat/i.test(k)) { removed.push(k); s.removeItem(k); } });
      });
      dbg('Cleared Swym client context keys:', removed);
    } catch (e) { dbg('clearSwymClientContext error', e); }
  }

  var swatRef = null;
  var lists = [];
  var activeList = null;
  var allItems = [];
  var currentPage = 1;
  window.WISHLIST_TOTAL_COUNT = 0;

  function setHeaderCountDirect(n) {
    try {
      var count = typeof n === 'number' ? n : parseInt(n, 10);
      if (isNaN(count)) count = 0;
      window.WISHLIST_TOTAL_COUNT = count;
      var sel = window.SWYM_WISHLIST_COUNT_SELECTOR || '.js-wishlist-count, .m-wishlist-count, .wishlist-h-count, .wishlist-total-count, [data-wishlist-count]';
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) {
          el.style.display = '';
          el.classList.remove('m:hidden');
        } else {
          el.style.display = 'none';
          el.classList.add('m:hidden');
        }
        try {
          el.setAttribute('data-count', String(count));
          el.setAttribute('data-total', String(count));
          if (el.dataset) { el.dataset.count = String(count); el.dataset.total = String(count); }
        } catch (_) { }
      });
    } catch (_) { }
  }
  window.setHeaderCountDirect = setHeaderCountDirect;

  if (debug) {
    dbg('Debug mode enabled via ?swymDebug=1');
    if (resetCtx) dbg('swymReset=1 detected - client context will be cleared before init.');
    dbg('apiBase:', apiBase || '(not set)');
    dbg('pageSize:', pageSize);
    dbg('listPrefix:', listPrefix || '(none)');
  }

  try {
    window.SWYM_LIST_PREFIX = listPrefix || '';
    try { localStorage.setItem('SWYM_LIST_PREFIX', window.SWYM_LIST_PREFIX); } catch (e) { }
    window.dispatchEvent(new CustomEvent('swym:list-prefix', { detail: { prefix: window.SWYM_LIST_PREFIX } }));
  } catch (e) { if (debug) { dbg('Failed to broadcast list prefix', e); } }

  if (resetCtx) { clearSwymClientContext(); }

  setTimeout(function () {
    if (typeof window.showWishlistLoader === 'function') {
      try { window.showWishlistLoader(); } catch (e) { }
    } else {
      var loader = document.getElementById('wishlistLoader');
      if (loader) { loader.style.display = 'flex'; loader.classList.remove('m-wishlist-loader--hiding'); }
    }
  }, 0);

  function onSwymReady(cb) {
    if (window._swat) { swatRef = window._swat; return cb(window._swat); }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) { swatRef = swat; cb(swat); });
    setTimeout(function () {
      if (!window._swat) {
        if (debug) { dbg('Swym SDK not detected on page. Ensure the Swym app embed/script is enabled for this theme.'); }
        try {
          var inEditor = (window.Shopify && Shopify.designMode) || /[?&]design_mode=1\b/.test(location.search);
          if (inEditor) {
            var banner = ensureDebugBanner();
            var msg = document.createElement('div');
            msg.style.marginTop = '6px';
            msg.textContent = 'Swym SDK is not loaded. In the Theme Editor, open App embeds and enable “Swym Wishlist Plus” (or the Swym app) for this theme, then refresh.';
            banner.appendChild(msg);
          }
        } catch (e) { }
      }
    }, 2000);
  }

  function setLoading(state) {
    section.classList.toggle('is-loading', !!state);
    if (state && typeof window.showWishlistLoader === 'function') {
      window.showWishlistLoader();
    } else if (!state && typeof window.hideWishlistLoader === 'function') {
      window.hideWishlistLoader();
    }
  }

  function getStoredActiveLid() {
    try { return localStorage.getItem('SWYM_ACTIVE_LID') || null; } catch (e) { return null; }
  }
  function setStoredActiveLid(lid) {
    try { if (lid) { localStorage.setItem('SWYM_ACTIVE_LID', String(lid)); } } catch (e) { }
    try { window.dispatchEvent(new CustomEvent('swym:active-list', { detail: { lid: lid } })); } catch (e) { }
  }

  var __autoRetriedOnce = false;
  function showError(message, retryCb) {
    try {
      if (!$items) return;
      var wrap = document.createElement('div');
      wrap.className = 'wishlist-error';
      wrap.style.cssText = 'background:#fff8f8;border:1px solid #f5c2c7;color:#842029;padding:12px;border-radius:6px;margin:12px 0;';
      var msg = document.createElement('div');
      msg.textContent = message || 'Unable to load wishlist at the moment.';
      wrap.appendChild(msg);
      if (typeof retryCb === 'function') {
        var btn = document.createElement('button');
        btn.textContent = 'Retry';
        btn.className = 'button';
        btn.style.marginTop = '8px';
        btn.addEventListener('click', function () { setLoading(true); try { retryCb(); } finally { } });
        wrap.appendChild(btn);
      }
      $items.innerHTML = '';
      $items.appendChild(wrap);
    } catch (e) { }
  }

  function addToCart(variantId, qty) {
    var vid = Number(variantId);
    if (isNaN(vid) || vid <= 0) { return Promise.reject(new Error('Invalid variant ID: ' + variantId)); }
    dbg('Adding to cart - Variant ID:', vid, 'Quantity:', qty || 1);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (text) {
          dbg('Cart add failed with status:', r.status, 'Response:', text);
          var errorMsg = 'Cart add failed: ' + r.status;
          try {
            var errorData = JSON.parse(text);
            if (errorData.description) { errorMsg = errorData.description; } else if (errorData.message) { errorMsg = errorData.message; } else if (errorData.status) { errorMsg = errorData.status; }
          } catch (e) { errorMsg += ' - ' + text; }
          if (r.status === 422) { errorMsg = 'This product variant is currently unavailable or out of stock.'; } else if (r.status === 404) { errorMsg = 'Product variant not found in the store.'; }
          var err = new Error(errorMsg); err.status = r.status; err.rawResponse = text; throw err;
        });
      }
      return r.json();
    }).then(function (result) { dbg('Successfully added to cart:', result); return result; });
  }

  function fetchLists() {
    return new Promise(function (resolve) {
      if (!swatRef || !swatRef.fetchLists) { resolve([]); return; }
      swatRef.fetchLists({ callbackFn: function (res) { if (Array.isArray(res)) return resolve(res); if (res && Array.isArray(res.lists)) return resolve(res.lists); resolve([]); } });
    });
  }

  function createList(name) {
    var baseName = name || 'My Wishlist';
    var finalName = listPrefix ? (baseName.indexOf(listPrefix) === 0 ? baseName : (listPrefix + baseName)) : baseName;
    return new Promise(function (resolve) {
      if (!swatRef || !swatRef.createList) { return resolve({ lid: null, name: finalName }); }
      swatRef.createList({ name: finalName, callbackFn: function (res) { var o = res; if (o && o.list) o = o.list; if (o && o.data) o = o.data; resolve(o || res); } });
    });
  }

  function dedupeItems(items) {
    if (!Array.isArray(items)) return [];
    var seen = {};
    return items.filter(function (it) {
      if (!it) return false;
      var key = '';
      if (it.empi != null && String(it.empi).trim()) {
        key = 'empi_' + String(it.empi).trim();
      } else if (it.du) {
        var cleanDu = String(it.du).split('?')[0].replace(/\/+$/, '');
        key = 'du_' + cleanDu;
      } else if (it.epi != null) {
        key = 'epi_' + String(it.epi).trim();
      } else if (it.id != null) {
        key = 'id_' + String(it.id).trim();
      }
      if (!key) return true;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function fetchListItems(lid) {
    return new Promise(function (resolve) {
      if (!swatRef) { return resolve([]); }
      if (swatRef.api) {
        swatRef.api({ method: 'GET', path: '/api/lists/' + encodeURIComponent(lid) + '?includeListContents=true' })
          .then(function (resp) {
            var arr = [];
            if (Array.isArray(resp)) { arr = resp; }
            else if (resp) {
              if (Array.isArray(resp.items)) arr = resp.items;
              else if (resp.contents && Array.isArray(resp.contents.items)) arr = resp.contents.items;
              else if (resp.list && Array.isArray(resp.list.items)) arr = resp.list.items;
              else if (resp.data && Array.isArray(resp.data.items)) arr = resp.data.items;
            }
            resolve(dedupeItems(arr));
          })
          .catch(function () { fallbackFetch(); });
      } else {
        fallbackFetch();
      }
      function fallbackFetch() {
        if (!swatRef.fetchListItems) { return resolve([]); }
        try {
          swatRef.fetchListItems({
            lid: lid, callbackFn: function (res) {
              if (Array.isArray(res)) return resolve(dedupeItems(res));
              if (res && Array.isArray(res.items)) return resolve(dedupeItems(res.items));
              if (res && res.contents && Array.isArray(res.contents.items)) return resolve(dedupeItems(res.contents.items));
              resolve([]);
            }
          });
        } catch (e) { resolve([]); }
      }
    });
  }

  function loadListItems(lid) { return fetchListItems(lid); }

  function removeFromListSafe(lid, ident) {
    return new Promise(function (resolve) {
      var payload = { lid: lid };
      if (ident && typeof ident === 'object') {
        if (ident.liid != null) payload.liid = ident.liid;
        if (ident.epi != null) payload.epi = ident.epi;
        if (ident.vi != null) payload.vi = ident.vi;
        if (ident.du) payload.du = ident.du;
      } else if (ident != null) {
        payload.epi = ident; 
      }
      if (!swatRef || !swatRef.removeFromList) { resolve(false); return; }
      try {
        swatRef.removeFromList({
          lid: payload.lid,
          liid: payload.liid,
          epi: payload.epi,
          vi: payload.vi,
          du: payload.du,
          callbackFn: function () { resolve(true); }
        });
      } catch (e) { resolve(false); }
    });
  }

  function resolveActiveLid() {
    var stored = getStoredActiveLid();
    return new Promise(function (resolve) {
      if (!swatRef || !swatRef.fetchLists) { resolve(stored || (activeList && (activeList.lid || activeList.id))); return; }
      try {
        swatRef.fetchLists({
          callbackFn: function (ls) {
            var raw = Array.isArray(ls) ? ls : (ls && Array.isArray(ls.lists) ? ls.lists : []);
            var pick = null;
            if (stored) { pick = raw.find(function (l) { return (l.lid || l.id || l.LID) == stored; }); }
            if (!pick) {
              var filtered = listPrefix ? raw.filter(function (l) { return ((l.name || l.title || '') + '').indexOf(listPrefix) === 0; }) : raw;
              pick = (filtered.find(function (l) { return (l.listcontents || []).length > 0; }) || filtered[0] || raw.find(function (l) { return (l.listcontents || []).length > 0; }) || raw[0] || {});
            }
            resolve(pick.lid || pick.id || pick.LID || stored || (activeList && (activeList.lid || activeList.id)) || null);
          }
        });
      } catch (e) { resolve(stored || (activeList && (activeList.lid || activeList.id))); }
    });
  }

  function moveItem(epi, fromLid, toLid) {
    return new Promise(function (resolve) {
      if (!swatRef || !swatRef.moveItem) { resolve(); return; }
      swatRef.moveItem({ epi: epi, fromLid: fromLid, toLid: toLid, callbackFn: resolve });
    });
  }

  function subscribeBackInStock(item, variantId) {
    try {
      var pid = item.epi || item.id || null;
      var vi = variantId || null;
      var name = item.dt || item.title || '';
      var url = item.du || location.href;

      var showCustomPopup = function () {
        var existing = document.getElementById('notify-me-popup-overlay');
        if (existing) existing.remove();

        var overlay = document.createElement('div');
        overlay.id = 'notify-me-popup-overlay';
        overlay.className = 'notify-me-popup-overlay';

        var popup = document.createElement('div');
        popup.className = 'notify-me-popup';

        popup.innerHTML = [
          '<div class="notify-me-popup-header">',
          '  <h2 class="notify-me-popup-title">Notify me when back in stock online</h2>',
          '  <button type="button" class="notify-me-popup-close" aria-label="Close">&times;</button>',
          '</div>',
          '<p class="notify-me-popup-description">We will send you a notification as soon as this product is available again.</p>',
          '<form class="notify-me-popup-form" id="notify-me-form">',
          '  <div class="notify-me-popup-field">',
          '    <label for="notify-first-name">First Name*</label>',
          '    <input type="text" id="notify-first-name" name="firstName" required>',
          '  </div>',
          '  <div class="notify-me-popup-field">',
          '    <label for="notify-email">Email*</label>',
          '    <input type="email" id="notify-email" name="email" required>',
          '  </div>',
          '  <div class="notify-me-popup-error" id="notify-me-error" style="display:none;"></div>',
          '  <div class="notify-me-popup-success" id="notify-me-success" style="display:none;"></div>',
          '  <button type="submit" class="notify-me-popup-submit">Notify me</button>',
          '</form>'
        ].join('');

        overlay.appendChild(popup);
        document.body.appendChild(overlay);

        setTimeout(function () {
          overlay.classList.add('active');
        }, 10);

        var form = popup.querySelector('#notify-me-form');
        var firstNameInput = popup.querySelector('#notify-first-name');
        var emailInput = popup.querySelector('#notify-email');
        var errorDiv = popup.querySelector('#notify-me-error');
        var successDiv = popup.querySelector('#notify-me-success');
        var submitBtn = popup.querySelector('.notify-me-popup-submit');

        function getKnownEmail() {
          try { if (window._swat && _swat.user && (_swat.user.email || _swat.user.em)) { return _swat.user.email || _swat.user.em; } } catch (e) { }
          try { if (window.CUSTOMER_EMAIL) return String(window.CUSTOMER_EMAIL); if (window.Shopify && Shopify.customer && Shopify.customer.email) return String(Shopify.customer.email); } catch (e) { }
          try { var m = document.cookie.match(/(?:^|; )swym_email=([^;]+)/); if (m) return decodeURIComponent(m[1]); } catch (e) { }
          return '';
        }

        var knownEmail = getKnownEmail();
        if (knownEmail) {
          emailInput.value = knownEmail;
        }

        var closeBtn = popup.querySelector('.notify-me-popup-close');
        var closePopup = function () {
          overlay.classList.remove('active');
          setTimeout(function () {
            overlay.remove();
          }, 300);
        };

        closeBtn.addEventListener('click', closePopup);
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) {
            closePopup();
          }
        });

        form.addEventListener('submit', function (e) {
          e.preventDefault();

          var firstName = firstNameInput.value.trim();
          var email = emailInput.value.trim();

          if (!firstName) {
            errorDiv.textContent = 'Please enter your first name';
            errorDiv.style.display = 'block';
            successDiv.style.display = 'none';
            return;
          }

          if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            errorDiv.textContent = 'Please enter a valid email address';
            errorDiv.style.display = 'block';
            successDiv.style.display = 'none';
            return;
          }

          errorDiv.style.display = 'none';
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';

          onSwymReady(function (swat) {
            if (swat && typeof swat.sendWatchlist === 'function') {
              var productProps = {
                epi: pid,
                empi: item.empi || pid,
                du: url,
                iu: item.iu || item.image_url || "",
                pr: Number(String(item.pr || item.price || 0).replace(/[R$€£¥₹,\s]/g, '')),
                et: 8
              };
              swat.sendWatchlist(email, "email", productProps,
                function (res) {
                  successDiv.textContent = 'Thank you! We will notify you when this product is back in stock.';
                  successDiv.style.display = 'block';
                  form.style.display = 'none';
                  submitBtn.style.display = 'none';

                  setTimeout(function () {
                    closePopup();
                  }, 2000);
                },
                function (err) {
                  errorDiv.textContent = 'Sorry, could not subscribe you right now. Please try again later.';
                  errorDiv.style.display = 'block';
                  submitBtn.disabled = false;
                  submitBtn.textContent = 'Notify me';
                }, 1);
            } else {
              errorDiv.textContent = '***Service temporarily unavailable. Please try again later.';
              errorDiv.style.display = 'block';
              submitBtn.disabled = false;
              submitBtn.textContent = 'Notify me';
            }
          });
        });
      };

      var trySwymPopup = function (swat) {
        if (!swat) return false;

        try {
          if (typeof swat.showNotifyMe === 'function') {
            var result = swat.showNotifyMe({
              epi: pid,
              vi: vi,
              du: url,
              dt: name
            });
            if (debug) dbg('Swym showNotifyMe called, result:', result);
            return true;
          }
        } catch (e) {
          if (debug) dbg('Swym showNotifyMe error:', e);
        }
        return false;
      };

      if (window._swat) {
        if (trySwymPopup(window._swat)) {
          return;
        }
      }

      onSwymReady(function (swat) {
        var attempts = 0;
        var maxAttempts = 3;
        var popupShown = false;

        var trySwym = function () {
          if (popupShown) return;

          attempts++;
          if (trySwymPopup(swat)) {
            popupShown = true;
            if (debug) dbg('Swym popup shown on attempt', attempts);
            return;
          }

          if (attempts < maxAttempts) {
            setTimeout(trySwym, 200 * attempts);
          } else {
            if (debug) dbg('Swym popup failed, showing custom popup');
            showCustomPopup();
          }
        };

        trySwym();
      });

      setTimeout(function () {
        if (!window._swat) {
          if (debug) dbg('Swym SDK not detected, showing custom popup');
          showCustomPopup();
        }
      }, 500);

    } catch (e) {
      try { console.warn('subscribeBackInStock failed', e); } catch (_e) { }
    }
  }

  function renderLists() { if (!$listSelect) return; $listSelect.innerHTML = ''; lists.forEach(function (l) { var opt = document.createElement('option'); opt.value = l.lid || l.id; opt.textContent = l.name || l.title; if (activeList && (activeList.lid || activeList.id) === (l.lid || l.id)) { opt.selected = true; } $listSelect.appendChild(opt); }); }

  function isLoggedIn() {
    try { return !!getKnownEmail(); } catch (e) {
      try { return !!window.CUSTOMER_EMAIL; } catch (_e) { return false; }
    }
  }

  function updateWishlistVisibility() {
    var $wishlistHeaderSection = document.querySelector('.wishlist-header-section');
    var $wishlistTitle = document.querySelector('.addwishlist_title, h1');
    var $wishlistItemCount = document.querySelector('.wishlist-item-count, .custom-wishlist-count');
    var loggedIn = isLoggedIn();

    if (allItems.length === 0) {
      if ($wishlistHeaderSection) $wishlistHeaderSection.style.display = 'none';
      if ($wishlistTitle) $wishlistTitle.style.display = 'none';
      if ($wishlistItemCount) $wishlistItemCount.style.display = 'none';
      if ($wishlistError) $wishlistError.style.display = 'none';
    } else {
      if ($wishlistHeaderSection) $wishlistHeaderSection.style.display = '';
      if ($wishlistTitle) $wishlistTitle.style.display = '';
      if ($wishlistItemCount) $wishlistItemCount.style.display = '';
    }
  }

  function renderPage() {
    if (!$items || !itemTpl) return;
    $items.innerHTML = '';
    var total = allItems.length;
    setHeaderCountDirect(total);
    var maxPage = Math.max(1, Math.ceil(total / pageSize));
    if (currentPage > maxPage) currentPage = maxPage;
    var start = (currentPage - 1) * pageSize;
    if (start >= total && total > 0) { currentPage = 1; start = 0; }
    var end = start + pageSize;
    var pageItems = allItems.slice(start, end);
    if (debug) { dbg('renderPage total=' + total + ' currentPage=' + currentPage + ' maxPage=' + maxPage + ' start=' + start + ' end=' + end + ' pageItems=' + pageItems.length); }
    if (pageItems.length === 0 && total > 0) {
      if (currentPage !== 1) { currentPage = 1; return renderPage(); }
    }
    if (total === 0) {
      setHeaderCountDirect(0);
      try { updateWishlistCount(); } catch (_e) { }
      if ($prev) $prev.disabled = true;
      if ($next) $next.disabled = true;
      if ($pageInfo) { $pageInfo.textContent = 'Page 1 of 1'; }
      updateWishlistVisibility();
      return;
    }
    pageItems.forEach(function (item) {
      var clone = itemTpl.content.cloneNode(true);
      var itemEl = clone.querySelector('.wishlist-item');
      if (itemEl) {
        var epiVal = item.epi || item.id || '';
        var variantVal = item.vi || item.variant_id || '';
        var rawUrl = item.du || item.product_url || '';

        var productUrl = rawUrl;
        if (rawUrl && variantVal) {
          try {
            var urlParts = rawUrl.split('?');
            var basePath = urlParts[0];
            productUrl = basePath + '?variant=' + variantVal;
          } catch (e) { productUrl = rawUrl; }
        }

        itemEl.setAttribute('data-epi', epiVal);
        itemEl.setAttribute('data-variantid', variantVal);

        var imgAnchors = clone.querySelectorAll('.wishlist-item__image');
        imgAnchors.forEach(function (anchor) {
          anchor.href = productUrl;
          anchor.style.pointerEvents = 'auto';
          anchor.style.cursor = 'pointer';
          anchor.addEventListener('click', function (e) {
            var target = e.target;
            if (target.closest('.wishlist-heart-icon') || target.closest('.wishlist-cart-icon')) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }, true);
        });

        var img = clone.querySelector('.wishlist-item__image img');
        if (img) {
          var imageUrl = item.iu || item.image_url || '';
          img.alt = item.dt || item.title || '';

          if (!imageUrl || imageUrl.trim() === '') {
            var handle = null;
            try {
              var urlPath = rawUrl || '';
              var match = urlPath.match(/\/products\/([^\/\?]+)/);
              if (match && match[1]) {
                handle = match[1];
              }
            } catch (e) { }

            if (handle) {
              fetch('/products/' + handle + '.js')
                .then(function (r) {
                  if (r.ok) return r.json();
                  throw new Error('Product not found');
                })
                .then(function (product) {
                  var imgSrc = null;

                  if (product && product.featured_image) {
                    var featuredImg = product.featured_image;
                    if (typeof featuredImg === 'string') {
                      imgSrc = featuredImg;
                    } else if (featuredImg && typeof featuredImg === 'object') {
                      imgSrc = featuredImg.src || featuredImg.url || (featuredImg.preview && featuredImg.preview.src) || null;
                    }
                  }

                  if (!imgSrc && product && product.images && Array.isArray(product.images) && product.images.length > 0) {
                    var firstImg = product.images[0];
                    if (typeof firstImg === 'string') {
                      imgSrc = firstImg;
                    } else if (firstImg && typeof firstImg === 'object') {
                      imgSrc = firstImg.src || firstImg.url || (firstImg.preview && firstImg.preview.src) || null;
                    }
                  }

                  if (imgSrc) {
                    if (!imgSrc.startsWith('http')) {
                      if (imgSrc.startsWith('//')) {
                        imgSrc = 'https:' + imgSrc;
                      } else if (imgSrc.startsWith('/')) {
                        imgSrc = window.location.origin + imgSrc;
                      } else {
                        imgSrc = 'https:' + (imgSrc.startsWith('//') ? imgSrc : '//' + imgSrc);
                      }
                    }

                    if (img && imgSrc) {
                      img.src = imgSrc;
                      img.onerror = null; 
                    }
                  }
                })
                .catch(function (e) {
                  if (debug) dbg('Failed to fetch product image for handle:', handle, e);
                  if (img) {
                    img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f0f0f0" width="400" height="400"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="18" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3ENo Image%3C/text%3E%3C/svg%3E';
                  }
                });
            } else {
              img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f0f0f0" width="400" height="400"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="18" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3ENo Image%3C/text%3E%3C/svg%3E';
            }
          } else {
            img.src = imageUrl;
            img.onerror = function () {
              var handle = null;
              try {
                var urlPath = rawUrl || '';
                var match = urlPath.match(/\/products\/([^\/\?]+)/);
                if (match && match[1]) {
                  handle = match[1];
                }
              } catch (e) { }

              if (handle) {
                fetch('/products/' + handle + '.js')
                  .then(function (r) {
                    if (r.ok) return r.json();
                    if (r.status === 404) return null; 
                    throw new Error('Product fetch failed');
                  })
                  .then(function (product) {
                    if (!product) return; 

                    var imgSrc = null;

                    if (product && product.featured_image) {
                      var featuredImg = product.featured_image;
                      if (typeof featuredImg === 'string') {
                        imgSrc = featuredImg;
                      } else if (featuredImg && typeof featuredImg === 'object') {
                        imgSrc = featuredImg.src || featuredImg.url || (featuredImg.preview && featuredImg.preview.src) || null;
                      }
                    }

                    if (!imgSrc && product && product.images && Array.isArray(product.images) && product.images.length > 0) {
                      var firstImg = product.images[0];
                      if (typeof firstImg === 'string') {
                        imgSrc = firstImg;
                      } else if (firstImg && typeof firstImg === 'object') {
                        imgSrc = firstImg.src || firstImg.url || (firstImg.preview && firstImg.preview.src) || null;
                      }
                    }

                    if (imgSrc) {
                      if (!imgSrc.startsWith('http')) {
                        if (imgSrc.startsWith('//')) {
                          imgSrc = 'https:' + imgSrc;
                        } else if (imgSrc.startsWith('/')) {
                          imgSrc = window.location.origin + imgSrc;
                        } else {
                          imgSrc = 'https:' + (imgSrc.startsWith('//') ? imgSrc : '//' + imgSrc);
                        }
                      }
                      if (img && imgSrc) {
                        img.src = imgSrc;
                      }
                    }
                  })
                  .catch(function (e) {
                    if (debug) dbg('Failed to fetch product image on error:', e);
                  });
              }
            };
          }
        }

        var title = clone.querySelector('.wishlist-item__title');
        if (title) {
          title.href = productUrl;
          title.textContent = item.dt || item.title || '';
          title.style.pointerEvents = 'auto';
          title.style.cursor = 'pointer';
        }

        var price = clone.querySelector('.wishlist-item__price');
        if (price) {
          var priceValue = item.pr || item.price || '';
          var variantId = item.vi || item.variant_id || '';

          
          var formatPrice = function (priceVal) {
            if (priceVal === null || priceVal === undefined || priceVal === '') return '';

            let str = priceVal.toString().trim();

            str = str.replace(/[R$€£¥₹,\s]/g, '');

            let num = Number(str);
            if (isNaN(num)) return priceVal;

            return 'R ' + num.toFixed(2);
          };




          if (priceValue) {
            price.textContent = formatPrice(priceValue, typeof priceValue === 'string');
          } else {
            var handle = null;
            try {
              var urlPath = rawUrl || '';
              var match = urlPath.match(/\/products\/([^\/\?]+)/);
              if (match && match[1]) {
                handle = match[1];
              }
            } catch (e) { }

            if (handle) {
              fetch('/products/' + handle + '.js')
                .then(function (r) {
                  if (r.ok) return r.json();
                  throw new Error('Product not found');
                })
                .then(function (product) {
                  var productPrice = null;

                  if (variantId && product && product.variants && Array.isArray(product.variants)) {
                    var variant = product.variants.find(function (v) {
                      return String(v.id) === String(variantId);
                    });
                    if (variant && variant.price) {
                      productPrice = variant.price;
                    }
                  }

                  if (!productPrice && product && product.price) {
                    productPrice = product.price;
                  }

                  if (!productPrice && product && product.price_min) {
                    productPrice = product.price_min;
                  }

                  if (productPrice && price) {
                    price.textContent = formatPrice(productPrice, false);
                  } else if (price) {
                    price.textContent = '';
                  }
                })
                .catch(function (e) {
                  if (debug) dbg('Failed to fetch product price for handle:', handle, e);
                  if (price) {
                    price.textContent = '';
                  }
                });
            } else {
              price.textContent = '';
            }
          }
        }
        var variantSelect = clone.querySelector('.wishlist-item__variant');
        if (variantSelect) {
          if (item.variants && Array.isArray(item.variants)) {
            item.variants.forEach(function (v) { var opt = document.createElement('option'); opt.value = v.id || v.variant_id; opt.textContent = v.title || v.name; if ((item.vi || item.variant_id) == (v.id || v.variant_id)) { opt.selected = true; } variantSelect.appendChild(opt); });
          } else { variantSelect.style.display = 'none'; }
        }
        var mobileCartBtn = clone.querySelector('.wishlist-cart-icon');
        var quickAddBtn = clone.querySelector('.wishlist-quick-add-btn');

        var heartBtn = clone.querySelector('.wishlist-heart-icon');
        var removeBtn = clone.querySelector('.wishlist-remove');
        var rawDu = item.du || item.product_url || item.url || '';
        var normalizedDu = (function (u) { try { return (u || '').split('?')[0]; } catch (e) { return u || ''; } })(rawDu);
        function setHeaderCountDirect(n) {
          try {
            var sel = window.SWYM_WISHLIST_COUNT_SELECTOR || '.js-wishlist-count';
            document.querySelectorAll(sel).forEach(function (el) { el.textContent = String(n); });
          } catch (_) { }
        }
        function forceHeaderCounters() {
          try { updateWishlistCount(); } catch (_) { }
          setTimeout(function () { try { setHeaderCountDirect(allItems.length); } catch (_) { } }, 50);
          try { if (window.swymWidgets && typeof window.swymWidgets.updateHeaderCount === 'function') { window.swymWidgets.updateHeaderCount(); } } catch (_) { }
        }
        function removeItemServer(payload) {
          return new Promise(function (resolve, reject) {
            var swat = swatRef || window._swat;
            if (!swat) { return reject(new Error('Swym SDK not ready')); }
            var done = false;
            function finish(ok) { if (!done) { done = true; ok ? resolve() : reject(new Error('Removal callback reported failure')); } }
            try {
              if (typeof swat.removeFromWishList === 'function') {
                if (debug) dbg('Calling swat.removeFromWishList with', payload);
                swat.removeFromWishList(payload, function () { finish(true); }, function () { finish(false); });
                return;
              }
              if (typeof swat.removeFromList === 'function' && payload.lid) {
                if (debug) dbg('Fallback swat.removeFromList with', payload);
                swat.removeFromList({ lid: payload.lid, liid: payload.liid, epi: payload.epi, vi: payload.vi, du: payload.du, callbackFn: function () { finish(true); } });
                return;
              }
              reject(new Error('No suitable Swym removal function available'));
            } catch (e) { reject(e); }
          });
        }
        function performRemoval() {
          var epiVal = item.epi || item.EPI || null; 
          var liidVal = item.liid || item.liId || item.LIID || null; 
          var productDu = normalizedDu; 
          if (!epiVal) { return Promise.resolve(); }
          var preItems = allItems.slice();
          function matchesTarget(x) { return x && String(x.epi || x.EPI) === String(epiVal); }
          return resolveActiveLid()
            .then(function (lid) {
              var payload = { epi: epiVal, du: productDu };
              if (liidVal) payload.liid = liidVal;
              if (lid) payload.lid = lid;
              return removeItemServer(payload).then(function () { return lid; }).catch(function (err) { if (debug) dbg('Server removal failed, will optimistic remove', err.message); return null; });
            })
            .then(function (lid) {
              if (lid) {
                return fetchListItems(lid).then(function (items) {
                  var serverArr = Array.isArray(items) ? items : [];
                  if (debug) dbg('Post-remove fetch length', serverArr.length);
                  if (serverArr.some(matchesTarget)) {
                    if (debug) dbg('Item still present; retrying removal with epi only');
                    return removeItemServer({ epi: epiVal, lid: lid }).then(function () {
                      return fetchListItems(lid).then(function (second) {
                        allItems = Array.isArray(second) ? second : serverArr.filter(function (x) { return !matchesTarget(x); });
                      });
                    }).catch(function () { allItems = serverArr.filter(function (x) { return !matchesTarget(x); }); });
                  } else {
                    allItems = serverArr;
                  }
                }).catch(function () { allItems = preItems.filter(function (x) { return !matchesTarget(x); }); });
              } else {
                allItems = preItems.filter(function (x) { return !matchesTarget(x); });
              }
            })
            .finally(function () {
              var maxPage = Math.max(1, Math.ceil(allItems.length / pageSize));
              if (currentPage > maxPage) currentPage = maxPage;
              renderPage();
              forceHeaderCounters();
              try { window.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (_e) { }
            });
        }
        function bindRemoval(btn) {
          if (!btn) return;
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (btn.disabled) return;
            btn.disabled = true;
            var originalHTML = btn.innerHTML;
            var originalText = btn.textContent;
            btn.classList.add('wishlist-removing');
            btn.innerHTML = 'Removing…';
            setLoading(true);
            performRemoval().finally(function () {
              setLoading(false);
              btn.disabled = false;
              btn.classList.remove('wishlist-removing');
              btn.innerHTML = originalHTML;
              if (heartBtn && heartBtn !== btn) { heartBtn.disabled = false; }
              if (removeBtn && removeBtn !== btn) { removeBtn.disabled = false; }
            });
          });
        }
        bindRemoval(heartBtn);
        bindRemoval(removeBtn);

      }

      var quickAddBtns = clone.querySelectorAll('.wishlist-quick-add-btn');
      quickAddBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var handle = null;
          try {
            var urlPath = item.du || item.product_url || '';
            var match = urlPath.match(/\/products\/([^\/\?]+)/);
            if (match && match[1]) {
              handle = match[1];
            }
          } catch (e) { }

          if (handle) {
            setLoading(true);
            fetch('/products/' + handle + '?sections=product-quickview')
              .then(function (r) { return r.json(); })
              .then(function (data) {
                if (data['product-quickview'] && $qvContent && $qvOverlay) {
                  $qvContent.innerHTML = data['product-quickview'];
                  $qvOverlay.classList.add('active');

                  setTimeout(function () {
                    try {
                      var picker = $qvContent.querySelector('variant-picker');
                      var formEl = $qvContent.querySelector('form[action*="/cart/add"]');
                      var mediaGallery = $qvContent.querySelector('media-gallery');

                      if (mediaGallery && (!mediaGallery.slider || !mediaGallery.slider.initialized)) {
                        console.log("mediaGallery init...");
                        try {
                          var SwiperConstructor = window.Swiper || (window.MinimogLibs && window.MinimogLibs.Swiper);
                          if (SwiperConstructor) {
                            var sliderEl = mediaGallery.querySelector('.swiper-container');
                            var thumbsEl = mediaGallery.querySelector('.nav-swiper-container');
                            var nextEl = mediaGallery.querySelector('.swiper-button-next');
                            var prevEl = mediaGallery.querySelector('.swiper-button-prev');
                            var paginationEl = mediaGallery.querySelector('.swiper-pagination');

                            var thumbsSwiper = null;
                            if (thumbsEl && thumbsEl.offsetParent !== null) {
                              try {
                                thumbsSwiper = new SwiperConstructor(thumbsEl, {
                                  spaceBetween: 10,
                                  slidesPerView: 4,
                                  freeMode: true,
                                  watchSlidesProgress: true,
                                  direction: 'vertical', 
                                  observer: true,
                                  observeParents: true,
                                  breakpoints: {
                                    0: { direction: 'horizontal', slidesPerView: 3 },
                                    768: { direction: 'vertical', slidesPerView: 4 }
                                  }
                                });
                              } catch (err) { console.warn('Thumbs swiper init failed', err); }
                            }

                            if (sliderEl) {
                              console.log("Slider init...");
                              var slides = sliderEl.querySelectorAll('.swiper-slide');
                              if (slides.length <= 1) {
                                if (nextEl) nextEl.style.display = 'none';
                                if (prevEl) prevEl.style.display = 'none';
                                if (paginationEl) paginationEl.style.display = 'none';
                                sliderEl.style.opacity = '1';
                              } else {
                                var mainConfig = {
                                  loop: true,
                                  autoHeight: true,
                                  observer: true,
                                  observeParents: true,
                                  navigation: {
                                    nextEl: nextEl,
                                    prevEl: prevEl,
                                  },
                                  pagination: {
                                    el: paginationEl,
                                    clickable: true,
                                    type: 'bullets',
                                  },
                                  thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
                                };

                                mediaGallery.slider = new SwiperConstructor(sliderEl, mainConfig);

                                sliderEl.style.opacity = '1';
                                if (thumbsEl) thumbsEl.style.opacity = '1';
                              }
                            }
                          }
                        } catch (e) { console.error('Manual Swiper init failed', e); }
                      }

                      if (picker && formEl) {
                        console.log("picker init...");
                        var sectionId = picker.dataset.sectionId || 'product-quickview';
                        var expectedId = 'product-form-' + sectionId;

                        if (formEl.id !== expectedId) {
                          formEl.id = expectedId;
                        }

                        if (!formEl.classList.contains(expectedId)) {
                          formEl.classList.add(expectedId);
                        }

                        picker.addEventListener('change', function () {
                          setTimeout(function () {
                            if (picker.currentVariant) {
                              var input = formEl.querySelector('input[name="id"]');
                              if (input) {
                                input.value = picker.currentVariant.id;
                                input.dispatchEvent(new Event('input', { bubbles: true }));
                              }

                              var addBtn = formEl.querySelector('[name="add"]');
                              var btnText = addBtn ? addBtn.querySelector('.m-add-to-cart--text') : null;

                              if (addBtn && !picker.currentVariant.available) {
                                if (!addBtn.disabled) addBtn.disabled = true;
                                if (btnText) btnText.textContent = window.MinimogStrings ? window.MinimogStrings.soldOut : 'Sold Out';
                              } else if (addBtn) {
                                if (addBtn.disabled) addBtn.disabled = false;
                                if (btnText) btnText.textContent = window.MinimogStrings ? window.MinimogStrings.addToCart : 'Add to cart';
                              }

                              var optionNodes = picker.querySelectorAll('variant-button, variant-color, variant-image, variant-select');
                              if (optionNodes) {
                                optionNodes.forEach(function (opt) {
                                  var selectedSpan = opt.querySelector('.option-label--selected');
                                  var checkedInput = opt.querySelector('input:checked');
                                  var select = opt.querySelector('select');

                                  var value = null;
                                  if (checkedInput) value = checkedInput.value;
                                  else if (select) value = select.value;

                                  if (selectedSpan && value) {
                                    selectedSpan.textContent = value;
                                  }
                                });
                              }
                            }
                          }, 50);
                        });

                        var allInputs = picker.querySelectorAll('input[type="radio"], select');
                        allInputs.forEach(function (el) {
                          el.addEventListener('change', function () {
                            var wrapper = el.closest('variant-button, variant-color, variant-image, variant-select');
                            if (wrapper) {
                              var label = wrapper.querySelector('.option-label--selected');
                              if (label) {
                                label.textContent = el.value;
                                label.classList.remove('m:text-color-error');
                              }
                            }

                            try {
                              var variantDataScript = picker.querySelector('#productVariants');
                              if (variantDataScript) {
                                var variants = JSON.parse(variantDataScript.textContent);
                                var selectedOptions = {};

                                picker.querySelectorAll('fieldset, .m-product-option--node').forEach(function (node) {
                                  var input = node.querySelector('input:checked');
                                  if (input) {
                                    var pos = node.dataset.optionPosition || input.dataset.optionPosition; // try both
                                    if (!pos && input.name) {
                                    }
                                    if (pos) selectedOptions['option' + pos] = input.value;
                                  }
                                });

                                picker.querySelectorAll('select').forEach(function (sel) {
                                  var opt = sel.options[sel.selectedIndex];
                                  var pos = sel.dataset.optionPosition || (opt ? opt.dataset.optionPosition : null);
                                  if (pos) selectedOptions['option' + pos] = sel.value;
                                });

                                var matchedVariant = variants.find(function (v) {
                                  for (var i = 1; i <= 3; i++) {
                                    var key = 'option' + i;
                                    
                                    if (v[key] && selectedOptions[key] && v[key] !== selectedOptions[key]) return false;

                                    
                                  }

                  
                                  return true;
                                });

                                if (matchedVariant) {
                                  var input = formEl.querySelector('input[name="id"]');
                                  if (input) {
                                    input.value = matchedVariant.id;
                                    input.dispatchEvent(new Event('input', { bubbles: true }));
                                  }

                                  var addBtn = formEl.querySelector('[name="add"]');
                                  var btnText = addBtn ? addBtn.querySelector('.m-add-to-cart--text') : null;

                                  if (addBtn && !matchedVariant.available) {
                                    if (!addBtn.disabled) addBtn.disabled = true;
                                    if (btnText) btnText.textContent = window.MinimogStrings ? window.MinimogStrings.soldOut : 'Sold Out';
                                    addBtn.classList.add('disabled');
                                  } else if (addBtn) {
                                    if (addBtn.disabled) addBtn.disabled = false;
                                    if (btnText) btnText.textContent = window.MinimogStrings ? window.MinimogStrings.addToCart : 'Add to cart';
                                    addBtn.classList.remove('disabled');
                                  }
                                }
                              }
                            } catch (e) { console.error('Manual variant sync failed', e); }

                            picker.dispatchEvent(new Event('change', { bubbles: true }));
                          });
                        });

                        picker.querySelectorAll('label').forEach(function (lbl) {
                          lbl.addEventListener('click', function (e) {
                            var inputId = lbl.getAttribute('for');
                            var input = null;
                            if (inputId) {
                              input = picker.querySelector('#' + inputId);
                            } else {
                              input = lbl.querySelector('input[type="radio"]');
                            }

                            if (input && input.type === 'radio' && !input.disabled) {
                              input.checked = true;
                              setTimeout(function () {
                                input.dispatchEvent(new Event('change', { bubbles: true }));
                              }, 10);
                            }
                          });
                        });


                        var closeQv = function () {
                          if ($qvOverlay && $qvOverlay.classList.contains('active')) {
                            $qvOverlay.classList.remove('active');
                            $qvContent.textContent = ''; 
                          }
                        };
                        if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
                          window.MinimogEvents.subscribe('cart-update', closeQv);
                          window.MinimogEvents.subscribe('open-cart-drawer', closeQv);
                        }
                        var addBtn = formEl ? formEl.querySelector('[name="add"]') : null;
                        if (addBtn) {
                          addBtn.addEventListener('click', function () {
                            var attempts = 0;
                            var poll = setInterval(function () {
                              attempts++;
                              var drawer = document.querySelector('m-cart-drawer');
                              var drawerOpen = drawer && (drawer.classList.contains('active') || drawer.classList.contains('m-drawer--open') || drawer.getAttribute('aria-hidden') === 'false' || drawer.hasAttribute('open'));

                              if (drawerOpen) {
                                closeQv();
                                clearInterval(poll);
                              }
                              if (attempts > 10) clearInterval(poll);
                            }, 500);
                          });
                        }

                        document.addEventListener('cart-update', closeQv);
                        document.addEventListener('open-cart-drawer', closeQv);


                        picker.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    } catch (e) { console.error('Error initializing wishlist quickview:', e); }
                  }, 100);
                }
              })
              .catch(function (e) {
                console.error('Failed to load quick view:', e);
              })
              .finally(function () {
                setLoading(false);
              });
          }
        });
      });

      $items.appendChild(clone);
    });

    updateWishlistVisibility();

    if ($prev) $prev.disabled = currentPage <= 1;
    if ($next) $next.disabled = end >= total;
    if ($pageInfo) { var totalPages = Math.max(1, Math.ceil(allItems.length / pageSize)); $pageInfo.textContent = 'Page ' + currentPage + ' of ' + totalPages; }
   
    try { if (typeof updateWishlistCount === 'function') { updateWishlistCount(); } } catch (e) { }
  }

  function bootstrap() {
    setLoading(true);
    fetchLists().then(function (ls) {
      var getUserName = function () {
        try {
          if (window.Shopify && Shopify.customer && Shopify.customer.first_name) {
            return Shopify.customer.first_name;
          }
          if (window.CUSTOMER_NAME) return String(window.CUSTOMER_NAME);
        } catch (e) { }
        return null;
      };
      var raw = (ls || []).map(function (l) {
        var baseName = l.name || l.title || ('List ' + (l.lid || l.id));
        if (/^List [a-zA-Z0-9\-]+$/.test(baseName)) {
          var user = getUserName();
          baseName = (user && user.trim() ? user.trim() : 'Ackermans') + ' list';
        }
        return { lid: l.lid || l.id || l.LID, name: baseName, listcontents: l.listcontents || l.items || [] };
      });
      var filtered = listPrefix ? raw.filter(function (l) { return (l.name || '').indexOf(listPrefix) === 0; }) : raw;
      if (debug) { dbg('Lists fetched:', raw.map(function (l) { return { name: l.name, lid: l.lid, items: (l.listcontents || []).length }; })); }
      
      var stored = getStoredActiveLid();
      var pick = null;
      if (stored) { pick = raw.find(function (l) { return String(l.lid) === String(stored); }); }
      if (!pick) { pick = (filtered.find(function (l) { return (l.listcontents || []).length > 0; }) || filtered[0] || raw.find(function (l) { return (l.listcontents || []).length > 0; }) || raw[0] || null); }
      if (!raw.length) {
        return createList('My Wishlist').then(function (newList) { var lid = newList.lid || newList.id || newList.LID; var name = newList.name || newList.title || (listPrefix ? (listPrefix + 'My Wishlist') : 'My Wishlist'); lists = [{ lid: lid, name: name }]; activeList = lists[0]; setStoredActiveLid(activeList.lid); });
      } else {
        lists = filtered.length ? filtered : raw;
        activeList = pick ? { lid: pick.lid, name: pick.name, listcontents: pick.listcontents } : (lists[0] || null);
        if (activeList && activeList.lid) { setStoredActiveLid(activeList.lid); }
      }
    }).then(function () {
      renderLists();
      if (activeList) {
        if (activeList.listcontents && Array.isArray(activeList.listcontents)) { allItems = activeList.listcontents; } else { return loadListItems(activeList.lid).then(function (items) { allItems = Array.isArray(items) ? items : []; }); }
      }
    }).then(function () {
      renderPage();
      if (typeof window.markWishlistDataLoaded === 'function') { try { window.markWishlistDataLoaded(); dbg('Wishlist data loaded signal sent'); } catch (e) { } }
      try { window.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (e) { }

      
      if (window.wishlistCountSyncInterval) {
        clearInterval(window.wishlistCountSyncInterval);
        window.wishlistCountSyncInterval = null;
      }

      updateWishlistCount();
    }).catch(function (err) {
      showError('Unable to load wishlist at the moment.', function () { bootstrap(); });
      if (!__autoRetriedOnce) { __autoRetriedOnce = true; setTimeout(function () { try { bootstrap(); } catch (e) { } }, 1200); }
      if (typeof window.markWishlistDataLoaded === 'function') { try { window.markWishlistDataLoaded(); } catch (e) { } }
    }).finally(function () { setLoading(false); });
  }

  $listSelect && $listSelect.addEventListener('change', function () { var lid = this.value; var sel = lists.find(function (l) { return (l.lid || l.id) === lid; }); if (!sel) return; activeList = { lid: sel.lid || sel.id, name: sel.name || sel.title }; setStoredActiveLid(activeList.lid); setLoading(true); fetchListItems(activeList.lid).then(function (items) { allItems = Array.isArray(items) ? items : []; currentPage = 1; renderPage(); try { window.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (_e) { } }).finally(function () { setLoading(false); }); });

  $createList && $createList.addEventListener('click', function () {
    var btn = this; var name = prompt('New list name:', 'Wishlist'); if (!name) return; var originalText = btn.textContent; btn.disabled = true; btn.textContent = 'Connecting...'; setLoading(true); btn.textContent = 'Creating...';
    createList(name).then(function (newList) { var entry = { lid: newList.lid || newList.id || newList.LID, name: newList.name || newList.title || name }; lists.push(entry); activeList = entry; renderLists(); return fetchListItems(activeList.lid).then(function (items) { allItems = items || []; }); }).then(function () { currentPage = 1; renderPage(); try { window.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (e) { } }).catch(function (err) { var msg = (err && err.message) ? err.message : 'Could not create list.'; alert(msg); }).finally(function () { setLoading(false); btn.disabled = false; btn.textContent = originalText; });
  });

  if ($shareBtn) {
    $shareBtn.addEventListener('click', function () {
      updateShareUrl(); 
      var drawer = document.getElementById('share-drawer');
      var overlay = document.getElementById('share-drawer-overlay');
      if (drawer && overlay) { drawer.classList.add('active'); overlay.classList.add('active'); }
    });
    var closeBtn = document.getElementById('share-drawer-close');
    var overlay = document.getElementById('share-drawer-overlay');
    if (closeBtn) { closeBtn.addEventListener('click', function () { var drawer = document.getElementById('share-drawer'); if (drawer) drawer.classList.remove('active'); if (overlay) overlay.classList.remove('active'); }); }
    if (overlay) { overlay.addEventListener('click', function () { var drawer = document.getElementById('share-drawer'); if (drawer) drawer.classList.remove('active'); overlay.classList.remove('active'); }); }
    var copyBtn = document.getElementById('share-copy-link');
    if (copyBtn) { copyBtn.addEventListener('click', function () { try { if ($shareUrl && $shareUrl.value) { navigator.clipboard.writeText($shareUrl.value).then(function () { alert('Link copied to clipboard!'); }).catch(function () { $shareUrl.select(); document.execCommand('copy'); alert('Link copied!'); }); } else { alert('Share URL not available yet.'); } } catch (e) { alert('Could not copy link.'); } }); }
    var fbBtn = document.getElementById('share-facebook');
    if (fbBtn) { fbBtn.addEventListener('click', function () { try { if ($shareUrl && $shareUrl.value) { window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($shareUrl.value), '_blank', 'width=600,height=400'); } } catch (e) { alert('Could not share to Facebook.'); } }); }
    var shareForm = document.getElementById('share-drawer-form');
    if (shareForm) {
      shareForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var recipientEmail = document.getElementById('share-recipient-email').value;
        var senderName = document.getElementById('share-sender-name').value;
        var message = document.getElementById('share-message').value;

        if (recipientEmail && senderName && message && $shareUrl && $shareUrl.value) {

          var mailtoLink = 'mailto:' + encodeURIComponent(recipientEmail) +
            '?subject=' + encodeURIComponent(senderName + ' shared a wishlist with you') +
            '&body=' + encodeURIComponent(message + '\n\n' + $shareUrl.value);

          setTimeout(function () {
            window.location.href = mailtoLink;
          }, 100);

          var drawer = document.getElementById('share-drawer');
          var overlay = document.getElementById('share-drawer-overlay');
          if (drawer) drawer.classList.remove('active');
          if (overlay) overlay.classList.remove('active');

          
          shareForm.reset();

          
          setTimeout(function () {
            location.reload();
          }, 1000);

        } else {
          alert('Please fill in all fields.');
        }
      });
    }


    function updateShareUrl() {
      try {
        if (!$shareUrl) return;
        $shareUrl.value = '';
        var hashtag = (activeList && typeof activeList.name === 'string' ? activeList.name : 'Wishlist');
        hashtag = hashtag.replace(/[^a-zA-Z0-9 _!&$#@ ,'’.\-]/g, '').trim();
        if (hashtag.length < 3) hashtag = 'Wishlist';
        if (hashtag.length > 50) hashtag = hashtag.substring(0, 50);

        var setFromResponse = function (response) {
          try {
            if (response && (response.url || response.shareUrl)) {
              $shareUrl.value = response.url || response.shareUrl;
              if (debug) console.log('[wishlist] Got Swym share URL:', $shareUrl.value);
              return;
            }
            if (typeof response === 'string') {
              $shareUrl.value = response;
              if (debug) console.log('[wishlist] Got Swym share URL (string):', $shareUrl.value);
              return;
            }
          } catch (e) {  }
          
          var fallback = window.location.origin + '/pages/wishlist' + (activeList && activeList.lid ? ('?lid=' + encodeURIComponent(activeList.lid)) : '');
          $shareUrl.value = fallback;
          if (debug) console.warn('[wishlist] Fallback share URL used.');
        };

        if (swatRef && typeof swatRef.generateSharedWishlistURL === 'function') {
          try {
            return swatRef.generateSharedWishlistURL(hashtag, setFromResponse);
          } catch (e1) { }
          try {
            return swatRef.generateSharedWishlistURL({ hashtag: hashtag, callbackFn: setFromResponse });
          } catch (e2) {  }
        }

        var fb = window.location.origin + '/pages/wishlist' + (activeList && activeList.lid ? ('?lid=' + encodeURIComponent(activeList.lid)) : '');
        $shareUrl.value = fb;
        if (debug) console.warn('[wishlist] Fallback share URL used (no SDK/failed).');
      } catch (e) {
        if (debug) console.error('[wishlist] updateShareUrl error', e);
        try {
          var fb2 = window.location.origin + '/pages/wishlist' + (activeList && activeList.lid ? ('?lid=' + encodeURIComponent(activeList.lid)) : '');
          $shareUrl.value = fb2;
        } catch (_e) { }
      }
    }
    document.removeEventListener('swym:lists-updated', updateShareUrl); 
    document.addEventListener('swym:lists-updated', updateShareUrl); updateShareUrl();
    console.log('[wishlist] Share button initialized for list:', window.CUSTOMER_EMAIL + ' here ');
    if (!window.Shopify || !window.CUSTOMER_EMAIL) {
      $shareBtn.style.display = 'none';
    }
  }

  $prev && $prev.addEventListener('click', function () { currentPage = Math.max(1, currentPage - 1); renderPage(); });
  $next && $next.addEventListener('click', function () { currentPage = currentPage + 1; renderPage(); });

  onSwymReady(function (swat) {
    if (debug) {
      try { var apiType = typeof (swat && swat.api); var hasFetchLists = !!(swat && swat.fetchLists); var hasSwymUtilsAjax = !!(window.SwymUtils && SwymUtils.ajax); dbg('Swym SDK loaded:', { apiType: apiType, hasFetchLists: hasFetchLists, hasSwymUtilsAjax: hasSwymUtilsAjax }); var banner = ensureDebugBanner(); var line = document.createElement('div'); line.textContent = 'SDK: ' + (swat ? 'yes' : 'no') + ', swat.api: ' + apiType + ', fetchLists: ' + (hasFetchLists ? 'yes' : 'no') + ', SwymUtils.ajax: ' + (hasSwymUtilsAjax ? 'yes' : 'no') + ', SwymUtils.ajax: ' + (hasSwymUtilsAjax ? 'yes' : 'no') + ', fetchListItems: ' + (swat.fetchListItems ? 'yes' : 'no'); banner.appendChild(line); } catch (e) { dbg('SDK status render error', e); }
    }
    try { bootstrap(); } catch (e) { setTimeout(bootstrap, 500); }
  });
})();


function updateWishlistCount() {
  try {
    var count = null;

    if (window.WISHLIST_TOTAL_COUNT !== undefined && window.WISHLIST_TOTAL_COUNT !== null && !isNaN(window.WISHLIST_TOTAL_COUNT)) {
      count = window.WISHLIST_TOTAL_COUNT;
    }

    if (count === null || count === undefined) {
      try {
        var headerCountEl = document.querySelector('.js-wishlist-count, .m-wishlist-count');
        if (headerCountEl && headerCountEl.textContent && headerCountEl.textContent.trim() !== '') {
          var headerCount = parseInt(headerCountEl.textContent.trim(), 10);
          if (!isNaN(headerCount)) {
            count = headerCount;
            window.WISHLIST_TOTAL_COUNT = count; 
          }
        }
      } catch (e) { }
    }

    if (count === null || count === undefined) {
      count = (document.querySelectorAll && document.querySelectorAll('.wishlist-item')) ? document.querySelectorAll('.wishlist-item').length : 0;
    }

    if (count === null || count === undefined) {
      count = 0;
    }

    try {
      if (typeof window.setHeaderCountDirect === 'function') {
        window.setHeaderCountDirect(count);
      } else {
        var sel = window.SWYM_WISHLIST_COUNT_SELECTOR || '.js-wishlist-count, .m-wishlist-count, .wishlist-h-count, .wishlist-total-count, [data-wishlist-count]';
        document.querySelectorAll(sel).forEach(function (el) {
          el.textContent = String(count);
          if (count > 0) {
            el.style.display = '';
            el.classList.remove('m:hidden');
          } else {
            el.style.display = 'none';
            el.classList.add('m:hidden');
          }
          try {
            el.setAttribute('data-count', String(count));
            el.setAttribute('data-total', String(count));
          } catch (_) { }
        });
      }
    } catch (_) { }

    var selectors = ['#wishlist-count', '.wishlist-count', '.custom-wishlist-count'];
    selectors.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      if (!els || !els.length) return;
      els.forEach(function (el) {
        el.textContent = count + (count === 1 ? ' item' : ' items');
      });
    });
  } catch (e) {  }
}


